import { render, staticRenderFns } from "./shelve.vue?vue&type=template&id=16958e05&scoped=true"
import script from "./shelve.vue?vue&type=script&lang=js"
export * from "./shelve.vue?vue&type=script&lang=js"
import style0 from "./shelve.vue?vue&type=style&index=0&id=16958e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16958e05",
  null
  
)

export default component.exports